module.exports = __webpack_public_path__ + "static/media/productDocumentation.0e7857e9.svg";